import { useScrollReveal } from '@/hooks/useScrollReveal';
import LogoMark from '@/components/LogoMark';

const Reframe = () => {
  const [ref, isVisible] = useScrollReveal();

  return (
    <section
      ref={ref}
      data-testid="reframe-section"
      className={`section-reveal ${isVisible ? 'visible' : ''}`}
      style={{ backgroundColor: '#42454A' }}
    >
      <div className="content-narrow">
        <LogoMark height={20} />

        <p className="reframe-thesis mt-8" data-testid="reframe-thesis">
          Most execution problems aren&rsquo;t execution problems. They&rsquo;re misalignment disguised as activity.
        </p>

        <p className="body-text mt-6" data-testid="reframe-body">
          Wrong priorities. Mispositioning. Cofounders pulling in different directions. Or being too deep in the business to see what&rsquo;s actually broken. The solution isn&rsquo;t working harder. It&rsquo;s seeing the problem you&rsquo;re too close to see &mdash; and cutting everything that isn&rsquo;t it.
        </p>
      </div>
    </section>
  );
};

export default Reframe;
